module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/testimonials-54c887a96069526df1fc1627caea64a3.jpg";